import { render } from "./OCRConfigForm.vue?vue&type=template&id=04a2be4e&scoped=true&ts=true"
import script from "./OCRConfigForm.vue?vue&type=script&lang=ts"
export * from "./OCRConfigForm.vue?vue&type=script&lang=ts"

import "./OCRConfigForm.vue?vue&type=style&index=0&id=04a2be4e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a2be4e"]])

export default __exports__